const routers = [
  {
    path: "/",
    redirect: "/auth",
  },
  {
    component: "MainLayout",
    path: "/auth",
    name: "Main",
    exact: false,
    redirect: "/auth/login",
    childrens: [
      {
        component: "Login",
        path: "/login",
        componentPath: "pages/Auth/Login",
        name: "Login",
        auth: false,
        exact: true,
      },
      {
        component: "ForgotPassword",
        path: "/forgot-password",
        componentPath: "pages/Auth/ForgotPassword",
        name: "ForgotPassword",
        auth: false,
        exact: true,
      },
      {
        component: "VerifyPassword",
        path: "/verify-password",
        componentPath: "pages/Auth/VerifyPassword",
        name: "VerifyPassword",
        auth: false,
        exact: true,
      },
      {
        component: "ResetPassword",
        path: "/reset-password",
        componentPath: "pages/Auth/ResetPassword",
        name: "ResetPassword",
        auth: false,
        exact: true,
      },
      //download order invoice
      {
        component: "DownloadOrderInvoice",
        path: "/download-invoice",
        componentPath: "pages/Dashboard/OrderManagement/DownloadOrderInvoice",
        name: "DownloadOrderInvoice",
        auth: false,
        exact: true,
      },
    ],
  },
  {
    component: "DashboardLayout",
    path: "/admin",
    name: "Main",
    exact: false,
    redirect: "/admin",
    childrens: [
      {
        component: "ListUser",
        path: "/",
        componentPath: "pages/Dashboard/UserManagement/ListUser",
        name: "ListUser",
        auth: false,
        exact: true,
      },
      {
        component: "ListUser",
        path: "/user",
        componentPath: "pages/Dashboard/UserManagement/ListUser",
        name: "ListUser",
        auth: false,
        exact: true,
      },
      {
        component: "EditRole",
        path: "/user/edit-role",
        componentPath: "pages/Dashboard/UserManagement/EditRole",
        name: "EditRole",
        auth: false,
        exact: true,
      },
      {
        component: "EditStaff",
        path: "/user/edit-staff",
        componentPath: "pages/Dashboard/UserManagement/EditStaff",
        name: "EditStaff",
        auth: false,
        exact: true,
      },
      {
        component: "ListOrder",
        path: "/list-order",
        componentPath: "pages/Dashboard/OrderManagement/ListOrder",
        name: "ListOrder",
        auth: false,
        exact: true,
      },
      {
        component: "ViewOrderDetails",
        path: "/list-order/order-details",
        componentPath: "pages/Dashboard/OrderManagement/ViewOrderDetails",
        name: "ViewOrderDetails",
        auth: false,
        exact: true,
      },

      {
        component: "ListProducts",
        path: "/list-products",
        componentPath: "pages/Dashboard/ProductManagement/ListProducts",
        name: "ListProducts",
        auth: false,
        exact: true,
      },
      {
        component: "ListCategory",
        path: "/list-category",
        componentPath: "pages/Dashboard/CategoryManagement/ListCategory",
        name: "ListCategory",
        auth: false,
        exact: true,
      },
      {
        component: "ListCartItems",
        path: "/list-cart",
        componentPath: "pages/Dashboard/CartManagement/ListCartItems",
        name: "ListCartItems",
        auth: false,
        exact: true,
      },
      {
        component: "ListCustomer",
        path: "/list-customer",
        componentPath: "pages/Dashboard/CustomerManagement/ListCustomer",
        name: "ListCustomer",
        auth: false,
        exact: true,
      },
      {
        component: "ViewCustomerDetails",
        path: "/list-customer/view-customer",
        componentPath: "pages/Dashboard/CustomerManagement/ViewCustomerDetails",
        name: "ViewCustomerDetails",
        auth: false,
        exact: true,
      },
      {
        component: "AddNewCustomer",
        path: "/list-customer/add-customer",
        componentPath: "pages/Dashboard/CustomerManagement/AddNewCustomer",
        name: "AddNewCustomer",
        auth: false,
        exact: true,
      },
      {
        component: "ViewCustomerGroup",
        path: "/list-customer/view-customer-group",
        componentPath: "pages/Dashboard/CustomerManagement/ViewCustomerGroup",
        name: "ViewCustomerGroup",
        auth: false,
        exact: true,
      },
      {
        component: "AddGroup",
        path: "/list-customer/add-group",
        componentPath: "pages/Dashboard/CustomerManagement/AddGroup",
        name: "AddGroup",
        auth: false,
        exact: true,
      },
      {
        component: "ListCoupon",
        path: "/list-coupon",
        componentPath: "pages/Dashboard/CouponManagement/ListCoupon.jsx",
        name: "ListCoupon",
        auth: false,
        exact: true,
      },
      {
        component: "ViewCoupon",
        path: "/list-coupon/view-coupon",
        componentPath: "pages/Dashboard/CouponManagement/ViewCoupon.jsx",
        name: "View-Coupon",
        auth: false,
        exact: true,
      },

      {
        component: "ViewCartDetail",
        path: "/list-cart/view-cart",
        componentPath: "pages/Dashboard/CartManagement/ViewCartDetail",
        name: "ViewCartDetail",
        auth: false,
        exact: true,
      },
      {
        component: "AddCoupon",
        path: "/list-coupon/add-coupon",
        componentPath: "pages/Dashboard/CouponManagement/AddCoupon",
        name: "AddCoupon",
        auth: false,
        exact: true,
      },
      {
        component: "CatlogManagement",
        path: "/list-catlog",
        componentPath: "pages/Dashboard/CatlogManagement/CatlogManagement",
        name: "CatlogManagement",
        auth: false,
        exact: true,
      },
      {
        component: "AddCatalogCategory",
        path: "/list-catlog/add-catlog-category",
        componentPath: "pages/Dashboard/CatlogManagement/AddCatalogCategory",
        name: "AddCatalogCategory",
        auth: false,
        exact: true,
      },
      {
        component: "AddCatalogCategory",
        path: "/list-catlog/edit-catlog-category/:categoryId",
        componentPath: "pages/Dashboard/CatlogManagement/AddCatalogCategory",
        name: "AddCatalogCategory",
        auth: false,
        exact: true,
      },
      {
        component: "AddNewProducts",
        path: "/list-catlog/add-catlog-product/:tabItem",
        componentPath: "pages/Dashboard/CatlogManagement/AddNewProducts",
        name: "AddNewProducts",
        auth: false,
        exact: true,
      },
      {
        component: "AddNewProducts",
        path: "/list-catlog/add-catlog-product/:productId/:tabItem",
        componentPath: "pages/Dashboard/CatlogManagement/AddNewProducts",
        name: "AddNewProducts",
        auth: false,
        exact: true,
      },
      {
        component: "AddNewProducts",
        path: "/list-catlog/edit-catlog-product/:productId/:tabItem",
        componentPath: "pages/Dashboard/CatlogManagement/AddNewProducts",
        name: "AddNewProducts",
        auth: false,
        exact: true,
      },

      {
        component: "AddNewPharamaProducts",
        path: "/list-catlog/add-catlog-pharama-product",
        componentPath: "pages/Dashboard/CatlogManagement/AddNewPharamaProduct",
        name: "AddNewPharamaProducts",
        auth: false,
        exact: true,
      },

      {
        component: "AddNewPharamaProducts",
        path: "/list-catlog/edit-catlog-pharama-product/:productId/:tabItem",
        componentPath: "pages/Dashboard/CatlogManagement/AddNewPharamaProduct",
        name: "AddNewPharamaProducts",
        auth: false,
        exact: true,
      },
      

      {
        component: "AddAndEditCatlogFilter",
        path: "/list-catlog/add-filter",
        componentPath:
          "pages/Dashboard/CatlogManagement/AddAndEditCatlogFilter",
        name: "AddAndEditCatlogFilter",
        auth: false,
        exact: true,
      },
      {
        component: "AddAndEditCatlogFilter",
        path: "/list-catlog/edit-filter/:filterId",
        componentPath:
          "pages/Dashboard/CatlogManagement/AddAndEditCatlogFilter",
        name: "AddAndEditCatlogFilter",
        auth: false,
        exact: true,
      },
      {
        component: "ListBanner",
        path: "/list-banner",
        componentPath: "pages/Dashboard/BannerManagement/ListBanner",
        name: "ListBanner",
        auth: false,
        exact: true,
      },
      {
        component: "AddNewBannerLightBox",
        path: "/list-banner/add-banner-light",
        componentPath: "pages/Dashboard/BannerManagement/AddNewBannerLightBox",
        name: "AddNewBannerLightBox",
        auth: false,
        exact: true,
      },
      {
        component: "AddNewBannerCategory",
        path: "/list-banner/add-banner-category",
        componentPath: "pages/Dashboard/BannerManagement/AddNewBannerCategory",
        name: "AddNewBannerCategory",
        auth: false,
        exact: true,
      },
      {
        component: "BannerManagement",
        path: "/list-banner/banner-view",
        componentPath: "pages/Dashboard/BannerManagement/BannerView",
        name: "BannerManagement",
        auth: false,
        exact: true,
      },
      {
        component: "ListTax",
        path: "/list-tax",
        componentPath: "pages/Dashboard/TaxConfigure/ListTax",
        name: "ListTax",
        auth: false,
        exact: true,
      },
      {
        component: "ListTax",
        path: "/list-catlog/add-tax",
        componentPath: "pages/Dashboard/CatlogManagement/AddCatlogTax",
        name: "AddCatlogTax",
        auth: false,
        exact: true,
      },
      {
        component: "ListTax",
        path: "/list-catlog/edit-tax/:id",
        componentPath: "pages/Dashboard/CatlogManagement/AddCatlogTax",
        name: "AddCatlogTax",
        auth: false,
        exact: true,
      },
      {
        component: "ListTax",
        path: "/list-catlog/view-tax-details/:id",
        componentPath:
          "pages/Dashboard/CatlogManagement/ViewCatlogTexDetailsPage",
        name: "ViewCatlogTexDetailsPage",
        auth: false,
        exact: true,
      },

      {
        component: "ListShipping",
        path: "/list-shipping",
        componentPath: "pages/Dashboard/ShippingConfigure/ListShipping",
        name: "ListShipping",
        auth: false,
        exact: true,
      },

      {
        component: "Reports",
        path: "/list-reports",
        componentPath: "pages/Dashboard/Reports/Reports",
        name: "Reports",
        auth: false,
        exact: true,
      },
      {
        component: "ListTestimonials",
        path: "/list-testimonials",
        componentPath:
          "pages/Dashboard/TestimonialsManagement/ListTestimonials",
        name: "ListTestimonials",
        auth: false,
        exact: true,
      },
      {
        component: "ListContentManagement",
        path: "/list-contents",
        componentPath:
          "pages/Dashboard/ContentManagement/ListContentManagement",
        name: "ListContentManagement",
        auth: false,
        exact: true,
      },

      {
        component: "ListBlogs",
        path: "/list-blogs",
        componentPath: "pages/Dashboard/Blogs/ListBlogs",
        name: "ListBlogs",
        auth: false,
        exact: true,
      },
      {
        component: "CreateBlogPost",
        path: "/list-blogs/create-blog-post",
        componentPath: "pages/Dashboard/Blogs/CreateBlogPost",
        name: "CreateBlogPost",
        auth: false,
        exact: true,
      },
      {
        component: "EditBlogPost",
        path: "/list-blogs/edit-blog-post",
        componentPath: "pages/Dashboard/Blogs/EditBlogPost",
        name: "EditBlogPost",
        auth: false,
        exact: true,
      },
      {
        component: "ViewBlogPost",
        path: "/list-blogs/view-blog-post",
        componentPath: "pages/Dashboard/Blogs/ViewBlogPost",
        name: "ViewBlogPost",
        auth: false,
        exact: true,
      },

      {
        component: "AddBlogCategory",
        path: "/list-blogs/add-blog-category",
        componentPath: "pages/Dashboard/Blogs/AddBlogCategory",
        name: "AddBlogCategory",
        auth: false,
        exact: true,
      },

      {
        component: "AddBlogCategory",
        path: "/list-blogs/edit-blog-category/:id",
        componentPath: "pages/Dashboard/Blogs/AddBlogCategory",
        name: "AddBlogCategory",
        auth: false,
        exact: true,
      },
      {
        component: "ListFaq",
        path: "/faq",
        componentPath: "pages/Dashboard/FaqManagement/ListFaq",
        name: "ListFaq",
        auth: false,
        exact: true,
      },
      {
        component: "ListAppointments",
        path: "/list-appointments",
        componentPath: "pages/Dashboard/AppointmentManagement/ListAppointments",
        name: "ListAppointments",
        auth: false,
        exact: true,
      },
      {
        component: "ViewAppointment",
        path: "/list-appointments/view-appointments",
        componentPath: "pages/Dashboard/AppointmentManagement/ViewAppointment",
        name: "ViewAppointment",
        auth: false,
        exact: true,
      },
      {
        component: "AddShippingconfiguration",
        path: "/list-shipping/add-shipping-configuration",
        componentPath:
          "pages/Dashboard/ShippingConfigure/AddShippingConfiguration",
        name: "AddShippingconfiguration",
        auth: false,
        exact: true,
      },
      {
        component: "ShippingView",
        path: "/list-shipping/shipping-view",
        componentPath: "pages/Dashboard/ShippingConfigure/ShippingView",
        name: "ShppingView",
        auth: false,
        exact: true,
      },
      {
        component: "BulkUpload",
        path: "/list-shipping/bulk-upload",
        componentPath: "pages/Dashboard/ShippingConfigure/BulkUpload",
        name: "BulkUpload",
        auth: false,
        exact: true,
      },
      {
        component: "EditShippingconfiguration",
        path: "/edit-shipping-configuration",
        componentPath:
          "pages/Dashboard/ShippingConfigure/EditShippingConfiguration",
        name: "EditShippingconfiguration",
        auth: false,
        exact: true,
      },
      {
        component: "Settings",
        path: "/settings",
        componentPath: "pages/Dashboard/Settings/Setting",
        name: "Settings",
        auth: false,
        exact: true,
      },

      {
        component: "TestimonialsView",
        path: "/list-testimonials/testimonials-view",
        componentPath:
          "pages/Dashboard/TestimonialsManagement/TestimonialsView",
        name: "TestimonialView",
        auth: false,
        exact: true,
      },
      {
        component: "TestimonialsCreate",
        path: "/list-testimonials/testimonials-create",
        componentPath:
          "pages/Dashboard/TestimonialsManagement/TestimonialsCreate",
        name: "TestimonialsCreate",
        auth: false,
        exact: true,
      },
      {
        component: "TestimonialsCreate",
        path: "/list-testimonials/testimonials-Edit/:id",
        componentPath:
          "pages/Dashboard/TestimonialsManagement/TestimonialsCreate",
        name: "TestimonialsCreate",
        auth: false,
        exact: true,
      },
      {
        component: "ListStoreList",
        path: "/list-store",
        componentPath: "pages/Dashboard/StorelocationManagement/ListStoreList",
        name: "ListStoreList",
        auth: false,
        exact: true,
      },
      {
        component: "AddNewLocation",
        path: "/list-store/add-store",
        componentPath: "pages/Dashboard/StorelocationManagement/AddNewLocation",
        name: "AddNewLocation",
        auth: false,
        exact: true,
      },
      {
        component: "AddNewLocation",
        path: "/list-store/edit-store",
        componentPath: "pages/Dashboard/StorelocationManagement/AddNewLocation",
        name: "AddNewLocation",
        auth: false,
        exact: true,
      },
      {
        component: "AddNewCity",
        path: "/list-store/add-City",
        componentPath: "pages/Dashboard/StorelocationManagement/AddNewCity",
        name: "AddNewCity",
        auth: false,
        exact: true,
      },
      {
        component: "AddNewCity",
        path: "/list-store/edit-City",
        componentPath: "pages/Dashboard/StorelocationManagement/AddNewCity",
        name: "AddNewCity",
        auth: false,
        exact: true,
      },
      {
        component: "AddNewService",
        path: "/list-store/add-service",
        componentPath: "pages/Dashboard/StorelocationManagement/AddNewService",
        name: "AddNewService",
        auth: false,
        exact: true,
      },
      {
        component: "AddNewService",
        path: "/list-store/edit-service",
        componentPath: "pages/Dashboard/StorelocationManagement/AddNewService",
        name: "AddNewService",
        auth: false,
        exact: true,
      },
      {
        component: "StoreView",
        path: "/list-store/store-view",
        componentPath: "pages/Dashboard/StorelocationManagement/StoreView",
        name: "StoreView",
        auth: false,
        exact: true,
      },
      {
        component: "StaticpageManagement",
        path: "/staticpage-management",
        componentPath:
          "pages/Dashboard/StaticpageManagement/StaticpageManagement",
        name: "StaticpageManagement",
        auth: false,
        exact: true,
      },
      {
        component: "StaticpageView",
        path: "/staticpage-management-view",
        componentPath: "pages/Dashboard/StaticpageManagement/StaticpageView",
        name: "StaticpageView",
        auth: false,
        exact: true,
      },

      {
        component: "StaticpageEdit",
        path: "/staticpage-management-edit",
        componentPath: "pages/Dashboard/StaticpageManagement/StaticpageEdit",
        name: "StaticpageEdit",
        auth: false,
        exact: true,
      },

      {
        component: "StaticpageCreate",
        path: "/staticpage-management-create",
        componentPath: "pages/Dashboard/StaticpageManagement/StaticpageCreate",
        name: "StaticpageCreate",
        auth: false,
        exact: true,
      },

      // details page - ashwin
      {
        component: "ViewProductDetailsPage",
        path: "/list-catlog/view-product-details/:id",
        componentPath:
          "pages/Dashboard/CatlogManagement/ViewProductDetailsPage",
        name: "ViewProductDetailsPage",
        auth: false,
        exact: true,
      },
      {
        component: "ViewCatlogFilterDetailsPage",
        path: "/list-catlog/view-filter-details/:filterId",
        componentPath:
          "pages/Dashboard/CatlogManagement/ViewCatlogFilterDetailsPage",
        name: "ViewCatlogFilterDetailsPage",
        auth: false,
        exact: true,
      },

      // Static Page
      {
        component: "ListStatic",
        path: "/list-static",
        componentPath: "pages/Dashboard/StaticManagement/ListStatic",
        name: "ListStatic",
        auth: false,
        exact: true,
      },
      {
        component: "AddListStatic",
        path: "/list-static/add",
        componentPath: "pages/Dashboard/StaticManagement/AddListStatic",
        name: "AddListStatic",
        auth: false,
        exact: true,
      },
    ],
  },
];
export default routers;
